<div class="page-inner-body portlet light ">
  <div class="portlet-body">
    <!-- Header Section with Title and Connect Button -->
    <div class="table-toolbar mb-4">
      <div class="row">
        <div class="col-md-12">
          <p-toolbar styleClass="bg-white">
            <div class="p-toolbar-group-start">
              <div class="d-flex flex-column justify-content-start align-items-start">
                <div class="d-flex align-items-center fs-5 fw-bold">
                  {{ 'connectWoocomerceAccount.connectYourAccount' | transloco }}
                </div>
                <div class="text-muted">
                  {{ 'connectWoocomerceAccount.manageConnections' | transloco }}
                </div>
              </div>
            </div>
            <div class="p-toolbar-group-end">
              <div class="text-end">
                <!-- Connect Account Button -->
                <button pButton type="button" class="p-button p-button-outlined p-button-sm fw-bold shadow-sm"
                  (click)="onShowWoocommerceAccountDailog()">
                  {{ 'connectWoocomerceAccount.connectWooCommerceAccount' | transloco }}
                  <i class="pi pi-plus ms-2"></i>
                </button>
              </div>
            </div>
          </p-toolbar>
        </div>
      </div>
    </div>

    <!-- Woocommerce Account Cards Section -->
    <div class="mt-4 border-bottom pb-4">
      <div class="row">
        <!-- Account Card - Repeats for each connected account -->
        @for (account of WoocommerceAccount; track account) {
          <div class="col-md-12 col-lg-4 mb-2">
            <div class="card border-0 shadow rounded-4 h-100">
              <div class="card-body p-4 d-flex flex-column justify-content-between position-relative">
                <!-- Account Menu Button (3 dots) -->
                <div class="position-absolute end-0 top-0 p-2">
                  <button class="btn btn-light btn-sm rounded-circle" (click)="WooCommerceMenuPanel.toggle($event)">
                    •••
                  </button>
                </div>
                <!-- Store Logo and Name -->
                <div class="d-flex align-items-center mb-2">
                  <img src="assets/images/woocommerace-log.png" [alt]="'connectWoocomerceAccount.wooCommerceLogo' | transloco" class="me-2"
                    style="height: 30px; width: 30px;" />
                    @if (account.StoreName) {
                      <div>
                        {{ account.StoreName }}
                      </div>
                    }
                  </div>
                  <!-- Store Details -->
                  @if (account.StoreURl) {
                    <div class="mb-1 d-flex align-items-center">
                      <div class="m-0 text-secondary">{{ 'connectWoocomerceAccount.urlLabel' | transloco }}</div>
                      <a [href]="account.StoreURl" target="_blank" class="text-primary text-decoration-none small ms-1">
                        {{ account.StoreURl }}
                      </a>
                    </div>
                  }
                  @if (account.City) {
                    <div class="mb-1 d-flex align-items-center">
                      <div class="m-0 text-secondary">{{ 'connectWoocomerceAccount.cityLabel' | transloco }}</div>
                      <div class="ms-2">{{ account.City }}</div>
                    </div>
                  }
                  @if (account.CountryState) {
                    <div class="mb-1 d-flex align-items-center">
                      <div class="m-0 text-secondary">{{ 'connectWoocomerceAccount.countryLabel' | transloco }}</div>
                      <div class="ms-2">{{ account.CountryState }}</div>
                    </div>
                  }
                  @if (account.Currency) {
                    <div class="mb-1 d-flex align-items-center">
                      <div class="m-0 text-secondary">{{ 'connectWoocomerceAccount.currencyLabel' | transloco }}</div>
                      <div class="ms-2">{{ account.Currency }}</div>
                    </div>
                  }
                  @if (account.CreatedDate) {
                    <div class="mb-1 d-flex align-items-center">
                      <div class="m-0 text-secondary">{{ 'connectWoocomerceAccount.connectedLabel' | transloco }}</div>
                      <div class="ms-2">{{ account.CreatedDate | date: 'dd/MM/yyyy' }}</div>
                    </div>
                  }
                  <!-- Account Management Menu (Hidden until 3 dots clicked) -->
                  <p-overlayPanel #WooCommerceMenuPanel>
                    <div class="px-2 py-2 small text-start">
                      <div class="mb-2 text-muted">{{ 'connectWoocomerceAccount.manageThisAccount' | transloco }}</div>
                      <!-- Disconnect Button -->
                      <button pButton type="button"
                        class="p-button p-button-danger p-button-sm w-100 justify-content-center text-center"
                        (click)="disconnectWoocommerceAccount(account); WooCommerceMenuPanel.hide()">
                        {{ 'connectWoocomerceAccount.disconnectAccount' | transloco }}
                      </button>
                      <!-- Disconnect Warning Information -->
                      <div class="text-muted mt-3 small">
                        {{ 'connectWoocomerceAccount.disconnectingWill' | transloco }}
                        <ul class="mt-1 ps-3">
                          <li>{{ 'connectWoocomerceAccount.stopSyncing' | transloco }}</li>
                          <li>{{ 'connectWoocomerceAccount.disableAutomation' | transloco }}</li>
                          <li>{{ 'connectWoocomerceAccount.reconnectAnytime' | transloco }}</li>
                        </ul>
                        {{ 'connectWoocomerceAccount.confirmBeforeProceed' | transloco }}
                      </div>
                    </div>
                  </p-overlayPanel>
                </div>
              </div>
            </div>
          }
        </div>

        <!-- Empty State Message -->
        @if (!WoocommerceAccount || WoocommerceAccount.length === 0) {
          <div class="text-center mt-4">
            <div class="text-muted">{{ 'connectWoocomerceAccount.noAccountDetails' | transloco }}</div>
          </div>
        }
      </div>

      <!-- Product Sync Component (Shows when accounts exist) -->
      @if (WoocommerceAccount && WoocommerceAccount.length > 0) {
        <div>
          <app-sync-products [SyncProducts]="Products"
          [wooCommerceSyncProducts]="wooCommerceSyncProducts"></app-sync-products>
        </div>
      }
    </div>
  </div>

  <!-- Add Woocommerce Account Dialog -->
  @if (isAddWoocommerceAccountDailogVisible) {
    <shopify-and-woocommerce-dailog [platform]="'woocommerce'"
      [isAddPlatformAccountDailogVisible]="isAddWoocommerceAccountDailogVisible"
      (onClosePlatformCredentialDailog)="onCloseWoocommerceAccountDailog($event)">
    </shopify-and-woocommerce-dailog>
  }

  <!-- Connection Success Dialog -->
  <p-dialog [header]="'connectWoocomerceAccount.connectionSuccessHeader' | transloco" [(visible)]="isConnectWoocommerceSuccessDialogVisible" [modal]="true"
    (onHide)="closeWooCommerceCheckoutDialog()" [style]="{ 'width': '430px'}">
    <div class="d-flex flex-column align-items-center px-3 py-3 text-center">
      <img src="assets/images/tik-image.jpg" [alt]="'connectWoocomerceAccount.success' | transloco" class="img-fluid rounded-circle" style="width: 100px;">
      <div class="h5 mt-4 text-secondary">
        {{ 'connectWoocomerceAccount.accountConnectedSuccessfully' | transloco }}
      </div>
      <div class="text-secondary">
        {{ 'connectWoocomerceAccount.storeLinkedSyncEnabled' | transloco }}
      </div>
    </div>
  </p-dialog>